import { computed, toValue } from "vue";
import { useClientProperties } from "./useClientProperties";
export const useClientProperty = (name) => {
    const { clientProperties } = useClientProperties();
    const clientProperty = computed(() => {
        const nameValue = toValue(name);
        if (!nameValue) {
            return undefined;
        }
        return clientProperties.value.find((property) => property.name === nameValue);
    });
    return {
        clientProperty,
    };
};
